import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { getDiffBetweenDatesInDays } from '@anecdotes/utils';
import { RegularDateFormatMMMdyyyy } from '@anecdotes/design-system/constants';

@Component({
  selector: 'app-due-date',
  templateUrl: './due-date.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DueDateComponent implements OnChanges {
  @HostBinding('class')
  private readonly classes = 'flex items-center';

  private get isDueDateToday(): boolean {
    const today = new Date();
    const dueDate = new Date(this.dueDate ?? 0);

    return (
      dueDate.getDate() === today.getDate() &&
      dueDate.getMonth() === today.getMonth() &&
      dueDate.getFullYear() === today.getFullYear()
    );
  }

  private get isDueDateExpired(): boolean {
    const currPlusExpireLimit = new Date();
    const dateObjOfDueDate = new Date(this.dueDate ?? 0);

    currPlusExpireLimit.setDate(currPlusExpireLimit.getDate());
    currPlusExpireLimit.setHours(0, 0, 0, 0);
    dateObjOfDueDate.setHours(0, 0, 0, 0);

    return currPlusExpireLimit >= dateObjOfDueDate;
  }

  svgIcon: string;
  translationKey: string;
  days: number;

  @Input()
  dueDate: Date;

  @Input()
  hasTooltip = true;

  @Input()
  tooltipDateFormat = RegularDateFormatMMMdyyyy;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.dueDate && changes.dueDate?.currentValue !== changes.dueDate?.previousValue) {
      this.resolveDueDate();
      this.cd.detectChanges();
    }
  }

  private buildTranslationKey(relativeKey: string): string {
    return `dueDate.${relativeKey}`;
  }

  private resolveDueDate(): void {
    if (this.isDueDateToday) {
      this.translationKey = this.buildTranslationKey('today');
      this.svgIcon = 'calander';
    } else if (this.isDueDateExpired) {
      this.translationKey = this.buildTranslationKey('overdue');
      this.svgIcon = 'status_not_started';
    } else {
      this.translationKey = this.buildTranslationKey('regular');
      this.svgIcon = 'calander';
    }

    this.days = Math.abs(getDiffBetweenDatesInDays(new Date(this.dueDate), new Date()));
  }
}
